import React            from 'react';
import { EAppPage }     from '@enums/common';
import { EInvoicePage } from '@enums/invoiceManagement';
import {
  LinkButton,
  LinksWrapper,
}                       from '@components/index';

interface IHeaderProps {
  push        : (path: string) => void;
  currentPage : string;
}

export const Header = ({
  push,
  currentPage,
}: IHeaderProps): JSX.Element => (
  <LinksWrapper>
    <LinkButton
      label   = "Invoice History"
      active  = {currentPage === EInvoicePage.InvoiceHistory}
      onClick = {
        (): void =>
          push(`${EAppPage.InvoiceManagement}/${EInvoicePage.InvoiceHistory}`)
      }
    />

    <LinkButton
      label   = "Default Pricing"
      active  = {currentPage === EInvoicePage.DefaultPricing}
      onClick = {
        (): void =>
          push(`${EAppPage.InvoiceManagement}/${EInvoicePage.DefaultPricing}`)
      }
    />

    <LinkButton
      label   = "Use Tax"
      active  = {currentPage === EInvoicePage.UseTax}
      onClick = {
        (): void =>
          push(`${EAppPage.InvoiceManagement}/${EInvoicePage.UseTax}`)
      }
    />

    {currentPage !== EInvoicePage.Search && (
      <LinkButton
        label   = "Return to Invoice Management"
        onClick = {
          (): void =>
            push(`${EAppPage.InvoiceManagement}/${EInvoicePage.Search}`)
        }
      />
    )}
  </LinksWrapper>
);
